<template>
  <div id="perfil_div">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card-title>
          <h1 class="headline mb-1">Rúbricas</h1>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogForm = true">Crear</v-btn>
          </v-card-title>
          <v-row>
            <v-col  
              md="3" dark
              v-for="rubrica_ in array_rubricas"
              v-if="rubrica_.tipo == 'imagen' || rubrica_.tipo == 'Imagen'"
              >
              <v-card
                :class="`firmas firma_${rubrica_.id}`"
                :hover="false"
                class="mx-auto">
                <div style="height: 100px; overflow: hidden;">
                  <img :src="rubrica_.base_64" v-if="rubrica_.tipo == 'imagen' || rubrica_.tipo == 'Imagen'">
                  
                </div>
                <v-card-subtitle class="pb-0">
                    <!-- {{rubrica_.id}} - --> {{rubrica_.nombre}}
                </v-card-subtitle>
                <v-card-actions>
                  <!-- <small>{{rubrica_.tipo}}</small> -->
                  <v-spacer></v-spacer>
                  <v-btn block @click="dialog=true;selected_id=rubrica_.id;"><v-icon left>delete</v-icon>Eliminar</v-btn>
                </v-card-actions>
              </v-card>
             
              <v-checkbox 
                v-model="rubrica_.prede"
                @change="predetermiar(rubrica_)"
                label="Predeterminado" >
              </v-checkbox>

            </v-col>
          </v-row>
            
          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline"></v-card-title>
              <v-card-text>Desea eliminar el item {{selected_id}}?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="dialog = false;">No</v-btn>
                <v-btn color="green darken-1" text @click="dialog = false;eliminar();">Si</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <ModalNuevaRubrica 
            v-if="dialogForm"
            :show_modal="dialogForm"
            v-on:rubrica-to-parent="onRubricaBack">
          </ModalNuevaRubrica>

        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
  import axios from "axios";
  import ModalNuevaRubrica from '@/components/documento/ModalNuevaRubrica.vue'; 

  export default {
    components: { 
      ModalNuevaRubrica,
    },
    data () {
      return {
          dialog: false,
          selected_id: 0,
          array_rubricas: [],
          dialogForm: false,
          items_tipo: ['Imagen', 'Texto'],
          items_color:[
            {'item': 'Rojo', "value": 'red'},
            {'item': 'Azul', "value": 'blue'},
            {'item': 'Negro', "value": '#000'},
            {'item': 'Verde', "value": 'green'},
          ],
        }
    },
    mounted() {
      console.log("rubricas.vue");
      this.getRubricas();
    },
    methods: {
      predetermiar(item) {
        
        console.log("Predeterminando Item id :" + item.id);
        this.$store.dispatch('SET_OVERLAY');
        let valor = 0;
        if (item.prede) {valor = 1} else {valor = 0}
        let getuser = axios.get('/Rubricas/Predeterminar?id=' + item.id + '&estado='+valor,  { 'headers': this.$store.state.user.headers });
        return getuser.then((callback) => {
          let resultado = callback.data;
          this.getRubricas();
          this.$forceUpdate();
        }).catch((error) => {
          this.$store.dispatch('UNSET_OVERLAY');
          this.texto_notificacion = 'Error al predeterminar';
          console.log(error);
        });
      },
      eliminar() {
        console.log("Deleting Item id :" + this.selected_id);
        this.$store.dispatch('SET_OVERLAY');
        console.log('/Rubricas/Eliminar?id=' + this.selected_id);
        let getuser = axios.delete('/Rubricas/Eliminar?id=' + this.selected_id ,  { 'headers': this.$store.state.user.headers })
        return getuser.then((callback) => {
          let resultado = callback.data;
          this.getRubricas();
          this.$forceUpdate();
        }).catch((error) => {
          this.$store.dispatch('UNSET_OVERLAY');
          this.texto_notificacion = 'Error al realizar la eliminar';
          console.log(error);
        });
      },
      getRubricas() {
        this.$store.dispatch('SET_OVERLAY');
        let getRubricas = axios.get('/Rubricas/Listar', { 'headers': this.$store.state.user.headers });
        return getRubricas.then((callback) =>
        {                     
          this.array_rubricas = callback.data;
          this.$store.dispatch('UNSET_OVERLAY');
        }).catch((error) => {
            this.texto_notificacion = "Error al obtener rúbricas"
            this.$store.dispatch('UNSET_OVERLAY');
            console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      onRubricaBack(obj){
        this.array_rubricas.push(obj.data);
        this.dialogForm = obj.modal;
      },
    }
  }
</script>